<template>
  <div>
    <div class="ln-border-8-wide ln-bg-light">
      <div class="row col-lg-9 col-md-12 p-4 position-relative">
        <h1 class="ln-doc-search-title ln-darkblue ml-4 noselect">Dokumentų paieška</h1>
        <router-link :to="`/help`" class="btn ml-3 ln-primary ln-pagalba">
          <font-awesome-icon
            :icon="['fas', 'question-circle']"
            class="mr-1 ln-question"
          />
          <span class="ln-subtitle-text ln-darkblue">Pagalba</span>
        </router-link>
      </div>
      <b-form v-if="ready" v-on:keyup.enter="onSubmit" class="px-2">
        <b-form-group
          label-cols-sm="12"
          label-cols-lg="2"
          content-cols-lg="7"
          label-align-lg="right"
          label="Numeris"
          label-for="search-regnr"
          label-class="ln-subtitle-text ln-darkblue noselect"
        >
          <b-form-row>
            <b-col>
              <b-form-input
                id="search-regnr"
                v-model="form.regNr"
                type="text"
                autocomplete="off"
              ></b-form-input>
            </b-col>
          </b-form-row>
        </b-form-group>
        <div class="ln-bck-darkergray pt-3 mt-1 pb-1 mb-3">
          <b-form-group
            label-cols-sm="12"
            label-cols-lg="2"
            content-cols-lg="7"
            label-align-lg="right"
            label="Žodžiai pavadinime"
            label-for="search-title-text"
            label-class="ln-subtitle-text ln-darkblue noselect"
          >
            <b-form-input
              id="search-title-text"
              v-model="form.titleText"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            style="position: relative"
            label-cols-sm="12"
            label-cols-lg="2"
            content-cols-lg="7"
            label-align-lg="right"
            label="Žodžiai tekste"
            label-for="search-content-text"
            label-class="ln-subtitle-text ln-darkblue noselect"
          >
            <b-form-input
              id="search-content-text"
              v-model="form.contentText"
              type="text"
            ></b-form-input>
            <div class="ln-chk-fraze-container">
              <div class="ln-fraze d-flex align-items-center">
                <input
                  id="search-text-fraze"
                  type="checkbox"
                  v-model="form.textFraze"
                  true-value="true"
                  false-value=""
                  class="ln-pointer"
                />
                <label for="search-text-fraze" class="ln-darkblue mb-0 ml-2 noselect ln-pointer">Frazė</label>
              </div>
            </div>
          </b-form-group>
        </div>
        <select-search-block
          :model.sync="form.documentType"
          :options="clasifs.documentTypes"
          label="Dokumento rūšis"
          placehold="Pasirinkite"
        />

        <b-form-group
          label-cols-md="12"
          label-cols-lg="2"
          content-cols-lg="9"
          label-align-lg="right"
          label-class="ln-subtitle-text ln-darkblue noselect"
          label="Data"
        >
          <b-form-row>
            <b-col class="col-lg-3 col-md-5">
              <date-picker-input
                v-model="form.dateFrom"
                input-id="data_nuo"
                placeholder="Nuo"
                aria-label="Data nuo"
                :min-year="minYear"
              />
            </b-col>
            <div class="p-2" aria-hidden="true">-</div>
            <b-col class="col-lg-3 col-md-5">
              <date-picker-input
                v-model="form.dateTo"
                input-id="data_iki"
                placeholder="Iki"
                aria-label="Data iki"
                :min-year="minYear"
              />
            </b-col>
          </b-form-row>
        </b-form-group>

        <b-collapse id="collapse-more-options" v-model="moreOptionsOpen">
          <select-search-block
            :model.sync="form.organization"
            :options="clasifs.organizations"
            label="Padalinys"
            placehold="Pasirinkite"
          />
          <select-search-block
            v-if="searchNuasmeninti && isAuthenticated"
            :model.sync="form.nuasmeninti"
            :options="nuasmenintiChk"
            label="Nuasmeninti dok."
            placehold="Pasirinkite"
          />

          <select-search-block
            v-if="searchStatus"
            :model.sync="form.status"
            :options="clasifs.statuses"
            label="Būsena"
          />
          <select-search-block
            v-if="searchRubrik == true"
            :model.sync="form.rubrika"
            :options="clasifs.rubricators"
            label="Rubrikatorius"
          />
          <div v-if="searchPublication == true">
            <b-form-group
              label-cols-sm="12"
              label-cols-lg="2"
              content-cols-lg="7"
              label-align-lg="right"
              label="Publikuota"
              label-class="ln-subtitle-text ln-darkblue noselect"
            >
              <b-form-row>
                <b-col class="col-lg-1 col-md-3 col-sm-10 sr-only">
                  <span class="align-middle">Leidinys</span>
                </b-col>
                <b-col class="col-lg-5 col-md-4 col-sm-12">
                  <b-form-select
                    id="search-leidinys"
                    class="form-control"
                    v-model="form.leidinys"
                    :options="clasifs.publicationTypes"
                    aria-label="Leidinys"
                  >
                    <template v-slot:first>
                      <option :value="''" disabled>Leidinys</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col class="col-lg-1 col-md-3 col-sm-10 sr-only">
                  <span class="align-middle">Data</span>
                </b-col>
                <b-col class="col-lg-4 col-md-4 col-sm-12">
                  <date-picker-input
                    v-model="form.metai"
                    input-id="data_publ"
                    placeholder="Publ. data"
                    aria-label="Publikavimo data"
                    :min-year="minYear"
                  />
                </b-col>
                <b-col class="col-lg-1 col-md-3 col-sm-10 sr-only">
                  <span class="align-middle">Leidinio Nr.</span>
                </b-col>
                <b-col class="col-lg-3 col-md-4 col-sm-12">
                  <b-form-input
                    id="search-pubnr"
                    type="text"
                    v-model="form.pubnr"
                    placeholder="Publ. Nr."
                    aria-label="Publikacijos numeris"
                  ></b-form-input>
                </b-col>
              </b-form-row>
            </b-form-group>
          </div>

          <div v-if="searchStakeholders">
            <b-form-group
              label-cols-sm="12"
              label-cols-lg="2"
              content-cols-lg="7"
              label-align-lg="right"
              label="Rengėjas"
              label-for="search-rengejas"
              label-class="ln-subtitle-text ln-darkblue noselect"
            >
              <b-form-input
                id="search-rengejas"
                class="custom-select ln-datalist"
                list="stakeholders-list-id"
                type="text"
                v-model="form.rengejas"
                autocomplete
              ></b-form-input>
              <datalist id="stakeholders-list-id">
                <option v-for="item in clasifs.stakeholders" :key="item.value">
                  {{ item.text }}
                </option>
              </datalist>
            </b-form-group>
          </div>
          <div v-if="searchSuvestinesRedakcijos" class="ln-suvestines-redakcijos-container">
            <b-form-group
              style="position: relative"
              label-cols-sm="12"
              label-cols-lg="2"
              content-cols-lg="7"
              label-align-lg="right"
              label="Suvestinės redakcijos"
              label-for="search-suvestines-redakcijos"
              label-class="ln-subtitle-text ln-darkblue noselect"
            >
              <b-form-row>
                <b-col>
                  <div class="ln-suvestines d-flex align-items-center">
                    <input
                      id="search-suvestines-redakcijos"
                      type="checkbox"
                      v-model="form.suvestinesRedakcijos"
                      true-value="true"
                      false-value=""
                      class="ln-pointer"
                    />
                  </div>
                </b-col>
              </b-form-row>
            </b-form-group>
          </div>
          
          <b-form-group
            v-if="quickSearchEnabled"
            label-cols-sm="12"
            label-cols-lg="2"
            content-cols-lg="7"
            label-align-lg="right"
            label="Greita paieška"
            label-class="ln-subtitle-text ln-darkblue noselect pt-0"
          >
            <b-form-row>
              <b-col class="ml-1 col-lg-2 col-md-4 pb-3">
                <button
                  type="button"
                  @click="quickSearch(6, $event)"
                  class="btn btn-link p-0 ln-subtitle-text-thin ln-primary"
                  style="text-decoration: underline"
                >
                  6 mėn.
                </button>
              </b-col>
              <b-col class="col-lg-2 col-md-4 pb-3">
                <button
                  type="button"
                  @click="quickSearch(12, $event)"
                  class="btn btn-link p-0 ln-subtitle-text-thin ln-primary"
                  style="text-decoration: underline"
                >
                  12 mėn.
                </button>
              </b-col>
            </b-form-row>
          </b-form-group>
          <category-multiselect
            v-if="categoriesData && categoriesData.length"
            :categories="categoriesData"
            :kategorijos.sync="form.kategorijos"
            :subkategorijos.sync="form.subkategorijos"
          />
        </b-collapse>

        <b-form-row>
          <div class="col-lg-2 col-sm-10"></div>
          <button
            type="button"
            @click="moreOptionsOpen = !moreOptionsOpen"
            @keyup.enter.stop
            :aria-expanded="moreOptionsOpen ? 'true' : 'false'"
            aria-controls="collapse-more-options"
            class="col-12 col-lg-auto ln-subtitle-text ln-primary btn btn-link text-left"
          >
            {{ moreOptionsOpen ? "Mažiau" : "Daugiau" }}
            <font-awesome-icon
              :icon="moreOptionsOpen ? ['fas', 'angle-up'] : ['fas', 'angle-down']"
              size="lg"
              class="ml-2 mr-2 ln-primary"
              aria-hidden="true"
            />
          </button>
        </b-form-row>

        <div class="ln-bt-g mt-3"></div>

        <div class="row mt-4 mb-4">
          <div class="col-lg-2 col-sm-2"></div>
          <div class="col-lg-3 col-sm-5">
            <b-button
              class="w-100 ml-0 pt-3 pb-3 ln-subtitle-text"
              type="button"
              variant="primary"
              @click="onSubmit"
            >
              <font-awesome-icon :icon="['fas', 'search']" class="mr-2" />
              Ieškoti
            </b-button>
          </div>
          <div class="col-lg-3 col-sm-5">
            <button
              type="button"
              class="w-100 pt-3 pb-3 ln-subtitle-text ln-darkblue ln-hover text-center btn btn-link"
              @click="onReset"
            >
              <font-awesome-icon :icon="['fas', 'times']" class="mr-2 ln-darkblue-half" aria-hidden="true" />
              Išvalyti
            </button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import SearchUrlParams from "../_Helpers/search-url-params";
import SelectSearchBlock from "./Components/SearchBlocks/select-search-block";
import CategoryMultiselect from "./Components/SearchBlocks/category-multiselect";
import DatePickerInput from "./Components/date-picker-input";
import { GetClassificators, GetCategories } from "@/Assets/repository";
import { getMinYear } from "@/_Helpers/min-year-cache";
import { userService } from "../_Services/user-service";

export default {
  name: "search-page",
  props: { cacheIsNeeded: Boolean },
  components: {
    SelectSearchBlock,
    CategoryMultiselect,
    DatePickerInput,
  },
  
  data() {
    return {
      moreOptionsOpen: this.$route.query.isplestine === "true" ? true : false,
      form: {
        regNr: "",
        dateFrom: "",
        dateTo: "",
        organization: "",
        documentType: "",
        titleText: "",
        contentText: "",
        status: "",
        rubrika: "",
        leidinys: "",
        metai: "",
        leidnr: "",
        pubnr: "",
        isplestine: "",
        textFraze: "",
        rengejas: "",
        nuasmeninti: "",
        suvestinesRedakcijos: false,
        kategorijos: [],
        subkategorijos: [],
      },
      clasifs: {},
      categoriesData: [],
      nuasmenintiChk: [
        { value: 0, text: "" },
        { value: true, text: "Nerodomi" },
        { value: false, text: "Rodomi" },
      ],
      ready: false,
      minYear: 1990,
    };
  },
  
  computed: {
    queryParams() {
      const params = SearchUrlParams.encode({
        nr: this.form.regNr,
        nuo: this.form.dateFrom,
        iki: this.form.dateTo,
        padalinys: this.form.organization,
        dokRusys: this.form.documentType,
        pavadinimas: this.form.titleText,
        tekstas: this.form.contentText,
        status: this.form.status,
        rubrika: this.form.rubrika,
        leidinys: this.form.leidinys,
        metai: this.form.metai,
        leidnr: this.form.leidnr,
        pubnr: this.form.pubnr,
        isplestine: this.moreOptionsOpen,
        textFraze: this.form.textFraze,
        rengejas: this.form.rengejas,
        nuasmeninti: this.form.nuasmeninti,
        suvestinesRedakcijos: this.form.suvestinesRedakcijos,
        kategorijos: this.form.kategorijos,
        subkategorijos: this.form.subkategorijos,
      });
    
      console.log('Query params:', params);
      return params;
    },
    searchRubrik() {
      return process.env.VUE_APP_SEARCH_RUBRIK === "true";
    },
    searchStatus() {
      return process.env.VUE_APP_SEARCH_STATUS === "true";
    },
    searchPublication() {
      return process.env.VUE_APP_SEARCH_PUBLICATION === "true";
    },
    quickSearchEnabled() {
      return process.env.VUE_APP_QUICK_SEARCH === "true";
    },
    searchStakeholders() {
      return process.env.VUE_APP_SHOW_STAKEHOLDERS === "true";
    },
    searchNuasmeninti() {
      return process.env.VUE_APP_SHOW_NUASMENINTI === "true";
    },
    isAuthenticated() {
      return userService.isAuthorized();
    },
    searchSuvestinesRedakcijos() {
      return process.env.VUE_APP_SHOW_SUVESTINES_REDAKCIJOS === "true";
    },
  },
  
  methods: {
    async fetchMinYear() {
      const year = await getMinYear();
      if (year) this.minYear = year; // kitu atveju lieka numatytieji 1990
    },
    onSubmit(evt) {
      evt.preventDefault();
      localStorage.removeItem("queryParams");
      this.$router.push("list" + this.queryParams);
      this.$emit("searchEvent");
    },
    onReset(evt) {
      evt.preventDefault();
      this.$store.dispatch("clearSearchCache");
      localStorage.removeItem("queryParams");
      this.form = {
        regNr: "",
        dateFrom: "",
        dateTo: "",
        organization: "",
        documentType: "",
        titleText: "",
        contentText: "",
        status: "",
        rubrika: "",
        leidinys: "",
        metai: "",
        leidnr: "",
        pubnr: "",
        isplestine: "",
        textFraze: "",
        rengejas: "",
        nuasmeninti: "",
        suvestinesRedakcijos: false,
        kategorijos: [],
        subkategorijos: [],
      };
    },
    focusField(id) {
      document.getElementById(id).focus();
    },
    quickSearch(range, event) {
      let dateTo = new Date();
      let dateFrom = new Date();
      dateFrom.setMonth(dateFrom.getMonth() - range);
      this.form.dateTo = dateTo.toISOString().slice(0, 10);
      this.form.dateFrom = dateFrom.toISOString().slice(0, 10);
      this.onSubmit(event);
    },
    saveTokenFromQuery() {
      let token = this.$route.query.token;
      let tokenExpires = this.$route.query.tokenExpires;
      if (!!token && !!tokenExpires) {
        localStorage.setItem("token", token);
        localStorage.setItem("tokenExpires", tokenExpires);
        localStorage.setItem("passwordExpired", "false");
        location.replace(process.env.VUE_APP_BASE_URL);
      }
    }
  },
  
  mounted() {
    this.saveTokenFromQuery();
    this.fetchMinYear();

    // Užkrauname klasifikatorius ir kategorijas lygiagrečiai
    Promise.all([
      GetClassificators(),
      GetCategories()
    ])
      .then(([classifsRes, categoriesRes]) => {
        this.clasifs = classifsRes.data;
        this.categoriesData = categoriesRes.data || [];
        this.ready = true;
      })
      .catch((ex) => {
        console.error(ex);
        this.ready = true;
      });
    
    SearchUrlParams.bind(this.form, this.$route.query);
    if (this.cacheIsNeeded === false) {
      this.$store.dispatch("clearSearchCache");
    }
  },
  
  created() {},
};
</script>

<style lang="css" scoped>
button.ln-hover:hover {
  outline: 2px solid #0056b3;
  outline-offset: 2px;
  text-decoration: none;
}
</style>